import getStore from '../data/store/store';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
/**
 * Utility function to log the usage of options.
 */
export default function logDataOnSaveEvents() {
    var currentState = getStore();
    if (!currentState) {
        return;
    }
    logReminderDefaultOption();
    logEventDurationDefaultOption();
}
function logReminderDefaultOption() {
    var currentState = getStore();
    if (currentState.defaultReminderTime != null) {
        var customData = datapoints.ReminderDefaultOption.datapoint.customData(currentState.defaultReminderTime);
        logUsage(datapoints.ReminderDefaultOption.datapoint.name, customData);
    }
}
function logEventDurationDefaultOption() {
    var currentState = getStore();
    if (currentState.defaultMeetingDuration != null) {
        var customData = datapoints.EventDurationDefaultOption.datapoint.customData(currentState.defaultMeetingDuration);
        logUsage(datapoints.EventDurationDefaultOption.datapoint.name, customData);
    }
}
//# sourceMappingURL=logDataOnSaveEvents.js.map